import {
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from '@chakra-ui/react'
import GroupItem from '../../Groups/GroupItem'
import usePrintCashInflowOutflow from '../../hooks/usePrintCashInflowOutflow'
import ContentForm from './ContentForm'

export default function ModalCashInflowOutflow() {
    const { isLoading, submit } = usePrintCashInflowOutflow()
    const { isOpen, onClose, onOpen } = useDisclosure()

    return (
        <>
            <GroupItem
                onClick={onOpen}
                label="Ingresos y Salidas de Efectivo"
            />
            <Modal isOpen={isOpen} onClose={onClose} size="sm">
                <ModalOverlay />
                <ModalContent p={4} pb={6}>
                    <ModalHeader textAlign="center">
                        Reporte de Ingresos y Salidas de Efectivo
                    </ModalHeader>
                    <ModalBody>
                        <ContentForm onSubmit={submit} isLoading={isLoading} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
